export function tenantCacheTag(subdomain?: string | null, tenantId?: string | null): string {
  return `${subdomain || 'root'}-${tenantId || 'anon'}`;
}
